<app-grid-page title="Software Updates">
  <div class="flex h-full min-h-0 flex-col gap-3">
    <div class="min-h-0 flex-1">
      <app-grid
        [columns]="columns"
        [data]="updates()"
        [rowId]="updateId"
        [loading]="isLoading()"
        [page]="page()"
        [pageSize]="size()"
        [totalElements]="totalElements()"
        [totalPages]="totalPages()"
        [sort]="sort()"
        [tabs]="tabs"
        [activeTabId]="activeTab()"
        [rowActions]="rowActions"
        [primaryAction]="{ label: 'Upload Update', icon: 'icon-content-add24px' }"
        (tabChange)="onTabChange($event)"
        (sortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (rowActionClick)="onRowAction($event.actionId, asUpdate($event.row))"
        (primaryActionClick)="openDialog()"
      >
        <ng-template gridCell="size" let-row>
          {{ formatSize(asUpdate(row).size) }}
        </ng-template>
      </app-grid>
    </div>
  </div>
</app-grid-page>

@if (isDetailDialogOpen() && detailUpdate()) {
  <app-software-update-detail-dialog
    [update]="detailUpdate()!"
    (close)="onViewDialogClose()"
  ></app-software-update-detail-dialog>
}

@if (isDialogOpen()) {
  <app-upload-software-update-dialog
    (close)="closeDialog()"
    (save)="handleUpload($event)"
  ></app-upload-software-update-dialog>
}
